import React, { useState, useEffect, useContext, useRef } from 'react'
import { Appointments } from '@devexpress/dx-react-scheduler-material-ui';
import { Col, Form, FormControl, InputGroup, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle, Row } from 'react-bootstrap'
import moment from 'moment-timezone';
import { RiDeleteBin6Line, RiEditBoxLine, RiCheckLine, RiCloseLine, RiPrinterLine, } from 'react-icons/ri'
import GlobalContext from '../../GlobalContext';
import { useImmer } from 'use-immer';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { useNavigate } from 'react-router-dom';
import TextContext from '../../TextContext';
import twCentMt from '../../fonts/tw-cen-mt-webfont.woff'
import twCentMtTitle from '../../fonts/tw-cen-mt-bold-webfont.woff'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import { RxUpdate } from "react-icons/rx";
import ServiceContext from '../../ServiceContext';
import GoodSwitch from '../../components/GoodSwitch';
import CalendarContext from '../../CalendarContext';
import { ImShare2 } from "react-icons/im";


pdfMake.vfs = pdfFonts.pdfMake.vfs;

const addMinutes = (h, add) => {
    const hour = parseInt(h.slice(0, 2))
    const minutes = parseInt(h.slice(3, 5))
    let htoadd = parseInt(add / 60)
    let mtoadd = (add - htoadd * 60) + minutes

    htoadd += hour

    if (mtoadd > 60) {
        htoadd += 1
        mtoadd -= 60
    }

    if (htoadd > 23) {
        htoadd = 23
    }


    const hstring = htoadd.toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false
    })

    const mstring = mtoadd.toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false
    })

    return `${hstring}:${mstring}`
}

const compTime = (a, b) => {
    const au = moment(a, 'HH:mm').unix()
    const bu = moment(b, 'HH:mm').unix()
    return au > bu
}
const getColor = (bgColor) => {
    const rgb = hexToRgb(bgColor)
    if (rgb) {
        const total = rgb.r + rgb.g + rgb.b
        return (total / 3) >= 128 ? '#000000' : '#ffffff'
    } else {
        return '#FFF'
    }
}
const hexToRgb = (hex) => {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    if (!hex) {
        return null
    }
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
    });

    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}
const isInteger = (number) => {
    if (!/^["|']{0,1}[-]{0,1}\d{0,}(.{0,1}\d+)["|']{0,1}$/.test(number)) return false;
    return !(number - parseInt(number));
}
const Appointment = ({ children, style, ...restProps }) => {

    const navigate = useNavigate()

    const calendarContext = useContext(CalendarContext)

    const [data, setData] = useImmer(children[1].props.data)
    const [showInfo, setShowInfo] = useState(false)
    const [showEdit, setShowEdit] = useState(false)
    const [showDelete, setShowDelete] = useState(false)
    const [showDeleteRec, setShowDeleteRec] = useState(false)
    const globalContext = useContext(GlobalContext)
    const serviceContext = useContext(ServiceContext)
    const textContext = useContext(TextContext)
    const animatedComponents = makeAnimated();
    const [userColorStyle, setUserColorStyle] = useState({})
    const [refreshSelect, setRefreshSelect] = useState(true)
    const [userOptions, setUserOptions] = useState([])
    const [values, setValues] = useImmer({
        ID: data.id,
        date: moment(data.startDate).format('YYYY-MM-DD'),
        start: moment(data.startDate, 'YYYY-MM-DDTHH:mm').format('HH:mm'),
        end: moment(data.endDate, 'YYYY-MM-DDTHH:mm').format('HH:mm'),
        allDay: data.allDay,
        title: data.title,
        note: data.note,
        category: data.category,
        customer: data.customer,
        contact: data.contact,
        appointmentID: data.aptID,
        autogen_title: data.eve_autogen_title,
        owner: { label: data.owner.use_username, value: data.owner.ID }
    })
    const [end, setEnd] = useState(moment(data.endDate, 'YYYY-MM-DDTHH:mm').format('HH:mm'))
    const [formChecks, setFormChecks] = useImmer({
        touched: {
            ID: false,
            date: false,
            start: false,
            end: false,
            allDay: false,
            title: false,
            note: false,
            category: false,
            customer: false,
            contact: false,
            appointmentID: false,
            owner: false,
        },
        check: {
            ID: (v) => { return true },
            date: (v) => { return v },
            start: (v) => { return true },
            end: (v) => { return true },
            allDay: (v) => { return true },
            title: (v) => { return v.length > 0 && v.length < 47 },
            note: (v) => { return v.length < 150 },
            category: (v) => { return v },
            customer: (v) => { return isAppointment ? v : true },
            owner: (v) => { return true },
            contact: (v) => { return true },
            appointmentID: (v) => { return true },
        },
        good: {
            ID: false,
            date: false,
            start: false,
            end: false,
            allDay: false,
            title: false,
            note: false,
            category: false,
            customer: false,
            contact: false,
            appointmentID: false,
            owner: false,
        },
        bad: {
            ID: false,
            date: false,
            start: false,
            end: false,
            allDay: false,
            title: false,
            note: false,
            category: false,
            customer: false,
            contact: false,
            appointmentID: false,
            owner: false,
        },
    })
    const [isAppointment, setIsAppointment] = useState(data.isAppointment)
    const [isShared, setIsShared] = useState(false)
    const categoryOptions = globalContext.get.categories.map(cat => ({ label: cat.cat_name, value: { ID: cat.ID, apt: cat.cat_apt }, }))
    const customerOptions = globalContext.get.customers.map(cus => ({ label: `${cus.cus_name} ${cus.cus_surname ? cus.cus_surname : ''}`, value: cus.ID }))
    const altCategory = useRef(undefined)

    const setTime = (cat) => {
        if (cat) {
            const cID = cat.value.ID
            const category = globalContext.get.categories.filter(cati => cati.ID == cID)[0]
            const start = values.start
            //console.log("start" ,addMinutes(start,category.cat_duration))
            setEnd(addMinutes(start, category.cat_duration))
            //setValues(draft=>{draft.end=`${moment(values.start, 'HH:mm').add(category.cat_duration,'minute').format('HH:mm')}`})
        } else {
            return
        }
    }
    const handleEditSubmit = async (mode = 0) => {
        if (!checkForm(values, formChecks, setFormChecks, true)) {
            console.log('non passato', formChecks)
            return
        }

        if (values.ID < 0 && mode == 0) {
            mode = 3
        }

        const EventBody = {
            ID: values.ID,
            eve_title: values.title,
            eve_note: values.note,
            eve_allDay: values.allDay,
            eve_start: moment(`${values.date} ${values.start}`, "YYYY-MM-DD HH:mm").unix(),
            eve_end: moment(`${values.date} ${end}`, "YYYY-MM-DD HH:mm").unix(),
            Category_ID: values.category.value.ID,
            mode: mode,
            eve_owner_ID: values.owner.value,
            eve_autogen_title: values.autogen_title
        }
        // console.log(data)
        if (mode) {
            EventBody.rec_ID = data.rec_ID
            EventBody.rec_index = data.rec_index
            EventBody.red_ID = data.red_ID
        }

        if (isAppointment) {
            if (values.appointmentID) {
                const AptBody = {
                    ID: values.appointmentID,
                    apt_contact: values.contact,
                    Customer_ID: values.customer.value
                }
                const resp = await fetch(`${globalContext.get.backendUrl}/papiv1/appointments`, {
                    method: 'PUT',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(AptBody)

                })
                const respValue = await resp.json()

            } else {
                const AptBody = {
                    apt_contact: values.contact,
                    Customer_ID: values.customer.value
                }
                const resp = await fetch(`${globalContext.get.backendUrl}/papiv1/appointments`, {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(AptBody)

                })
                const respValue = await resp.json()

                EventBody.Appointment_ID = respValue.data.ID
            }
        } else {
            if (values.appointmentID) {
                const AptBody = {
                    ID: values.appointmentID
                }
                const resp = await fetch(`${globalContext.get.backendUrl}/papiv1/appointments`, {
                    method: 'DELETE',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(AptBody)

                })
                const respValue = await resp.json()
                EventBody.Appointment_ID = null

            }
        }

        const resp = await fetch(`${globalContext.get.backendUrl}/papiv1/events`, {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(EventBody)
        })
        // globalContext.set(draft => { draft.Reloads.events = true })
        if (resp.status == 200) {
            serviceContext.set(draft => {
                draft.Alerts.push({
                    ID: Math.random(),
                    message: textContext.get(['calendar', 'notify'], ['success_modify'], textContext.value),
                    ttl: 2000
                })
            })
        } else {
            serviceContext.set(draft => {
                draft.Alerts.push({
                    ID: Math.random(),
                    message: textContext.get(['calendar', 'notify'], ['error_event'], textContext.value),
                    ttl: 2000
                })
            })
        }
        closeEdit()
    }
    const checkForm = (values, check, setCheck, show = false) => {
        let pass = true
        //console.log('check')
        Object.keys(values).forEach(k => {
            //console.log(check.check[k])
            try {
                if (check.check[k](values[k])) {

                    if (show || check.touched[k]) {
                        setCheck(draft => { draft.good[k] = true })
                        setCheck(draft => { draft.bad[k] = false })
                    }
                } else {
                    pass = false
                    if (show || check.touched[k]) {
                        setCheck(draft => { draft.bad[k] = true })
                        setCheck(draft => { draft.good[k] = false })
                    }
                }
            } catch {

            }

        })
        return pass
    }
    const closeEdit = () => {
        setShowEdit(false)
        setShowInfo(false)
    }
    const createPdf = () => {
        pdfMake.fonts = {
            twCent: {
                normal: `${globalContext.get.frontendUrl}${twCentMt}`,
                bold: `${globalContext.get.frontendUrl}${twCentMt}`,
                italics: `${globalContext.get.frontendUrl}${twCentMt}`,
                bolditalics: `${globalContext.get.frontendUrl}${twCentMt}`,
            },
            twCentTitle: {
                normal: `${globalContext.get.frontendUrl}${twCentMtTitle}`,
                bold: `${globalContext.get.frontendUrl}${twCentMtTitle}`,
                italics: `${globalContext.get.frontendUrl}${twCentMtTitle}`,
                bolditalics: `${globalContext.get.frontendUrl}${twCentMtTitle}`,
            }
        }
        const docDefinition = {
            defaultStyle: {
                font: 'twCent',
                fontSize: 20,
                alignment: 'center'
            },
            pageSize: 'A6',
            info: {
                title: `Reminder appuntamento ${data.customer.label}`,
            },
            content: [
                { text: textContext.get(['event', 'print_event'], ['title'], textContext.value), fontSize: 30, font: 'twCentTitle' },
                data.customer.label,
                `${textContext.get(['event', 'print_event'], ['il'], textContext.value)} ${moment(data.startDate, 'YYYY-MM-DDTHH:mm').format('DD/MM/YYYY')}`,
                `${textContext.get(['event', 'print_event'], ['hour'], textContext.value)} ${moment(data.startDate, 'YYYY-MM-DDTHH:mm').format('HH:mm')}`,
                data.category.label,
                `${textContext.get(['event', 'print_event'], ['where'], textContext.value)} ${globalContext.get.selectedShop.sho_sms_sender}`
            ],
        }

        pdfMake.createPdf(docDefinition).open();
    }
    const resetEdit = () => {
        setValues({
            ID: data.id,
            date: moment(data.startDate).format('YYYY-MM-DD'),
            start: moment(data.startDate, 'YYYY-MM-DDTHH:mm').format('HH:mm'),
            end: moment(data.endDate, 'YYYY-MM-DDTHH:mm').format('HH:mm'),
            allDay: data.allDay,
            title: data.title,
            note: data.note,
            category: data.category,
            customer: data.customer,
            contact: data.contact,
            appointmentID: data.aptID,
            autogen_title: data.eve_autogen_title,
            owner: { label: data.owner.use_username, value: data.owner.ID }
        })
        setEnd(moment(data.endDate, 'YYYY-MM-DDTHH:mm').format('HH:mm'))
        setShowEdit(false)
    }
    const getPermission = (permission, pos = -1) => {
        if (globalContext.get) {
            if (globalContext.get.User) {
                if (globalContext.get.User.Groups) {
                    if (globalContext.get.User.Groups.length > 0) {
                        if (globalContext.get.User.Groups[0].gro_is_admin) {
                            return true
                        } else {
                            if (pos >= 0) {
                                return parseInt(globalContext.get.User.Groups[0][permission].charAt(pos)) == 1
                            } else {
                                return globalContext.get.User.Groups[0][permission]
                            }
                        }
                    }
                }
            }
        }
        return false
    }
    const showDeleteEvent = () => {
        // console.log(data)
        if (data.rec_ID) {
            setShowDeleteRec(true)
        } else {
            setShowDelete(true)
        }
    }
    const deleteEvent = async (mode = 0) => {
        const body = {
            ID: data.id
        }
        if (mode == 1) {
            body.rec_ID = data.rec_ID
            body.rec_index = data.rec_index
            body.mode = mode
        } else if (mode == 2) {
            body.rec_ID = data.rec_ID
            body.rec_index = data.rec_index
            body.mode = moment.utc(data.startDate, "YYYY-MM-DDTHH:mm").unix()
        }
        if (data.red_ID) {
            body.mode = 3
            body.red_ID = data.red_ID
        }
        const resp = await fetch(`${globalContext.get.backendUrl}/papiv1/events`, {
            method: 'DELETE',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body)
        })
        const respValue = await resp.json()

        if (resp.status == 200) {
            // globalContext.set(draft => { draft.Reloads.events = true })
            serviceContext.set(draft => {
                draft.Alerts.push({
                    ID: Math.random(),
                    message: textContext.get(['calendar', 'notify'], ['success_delete'], textContext.value),
                    ttl: 2000
                })
            })
        } else {
            serviceContext.set(draft => {
                draft.Alerts.push({
                    ID: Math.random(),
                    message: textContext.get(['calendar', 'notify'], ['error_delete'], textContext.value),
                    ttl: 2000
                })
            })
        }
        setShowDelete(false)
        setShowDeleteRec(false)
        setShowInfo(false)
    }
    const setTimeStart = (value) => {

        const startMinutes = parseInt(String(value).substring(0, 2)) * 60 + parseInt(String(value).substring(3, 5))
        const endMinutes = parseInt(String(end).substring(0, 2)) * 60 + parseInt(String(end).substring(3, 5))
        if (startMinutes < endMinutes) {
            setValues(draft => { draft.start = value })
        }

    }
    const setTimeEnd = (value) => {

        const startMinutes = parseInt(String(values.start).substring(0, 2)) * 60 + parseInt(String(values.start).substring(3, 5))
        const endMinutes = parseInt(String(value).substring(0, 2)) * 60 + parseInt(String(value).substring(3, 5))
        if (startMinutes < endMinutes) {
            setEnd(value)
        }

    }
    const switchIsAppointment = (e) => {
        setIsAppointment(e)
        const tempAltCategory = altCategory.current
        altCategory.current = values.category
        setValues(draft => { draft.category = tempAltCategory })
        setRefreshSelect(false)
    }
    const updateCategory = () => {
        const catID = data.category.value.ID
        let category = globalContext.get.categories.filter(cat => cat.ID == catID)
        if (category.length > 0) {
            category = category[0]
        } else {
            return
        }

        setData(draft => {
            draft.category = {
                label: category.cat_name,
                value: {
                    ID: category.ID,
                    apt: category.cat_apt
                }
            };
            draft.color = category.cat_color
        })

    }

    useEffect(() => {
        setData(children[1].props.data)
        // console.log(children[1].props.data)
    }, [children[1].props.data])
    useEffect(() => {
        setRefreshSelect(true)
    }, [refreshSelect])
    useEffect(() => {
        checkForm(values, formChecks, setFormChecks)
    }, [values])
    useEffect(() => {
        if (data.isBirthday) {
            return
        }
        if (calendarContext.get.refreshCategories) {
            updateCategory()
        }
    }, [calendarContext.get, globalContext.get])
    useEffect(() => {
        if (data.isBirthday) {
            return
        }
        if (globalContext.get.showUsersList && ![1, 2].includes(globalContext.get.showUsersList)) {
            if (globalContext.get.showUsersList.length > 1) {
                if (data.isGlobal) {
                    setUserColorStyle({
                        borderRightColor: data.owner.use_color,
                        borderRightWidth: '15px',
                    })
                } else {
                    setIsShared(false)
                    setUserColorStyle({
                        borderLeftColor: data.owner.use_color,
                        borderLeftWidth: '15px',
                    })
                }
            } else {
                if (data.isGlobal) {
                    setUserColorStyle({
                        borderRightColor: data.owner.use_color,
                        borderRightWidth: '15px',
                    })
                    setIsShared(true)
                } else {
                    setIsShared(false)
                }
                setUserColorStyle({
                    borderLeftColor: data.owner.use_color,
                    borderLeftWidth: '0px',
                })
            }
        }
    }, [globalContext.get.showUsersList])
    useEffect(() => {
        if (globalContext.get.User.ID && globalContext.get.Shop.ID && globalContext.get.Agency.ID) {
            let l_users = []
            let ids = []
            globalContext.get.shops.forEach(sho => {
                sho.Users.forEach(use => {
                    if (!ids.includes(use.ID)) {
                        ids.push(use.ID)
                        l_users.push({ label: use.use_username, value: use.ID })
                    }
                })
            })
            setUserOptions(l_users)
        }
    }, [globalContext.get])

    return (
        <Appointments.Appointment
            {...restProps}
            style={{
                ...style,
                backgroundColor: data.color,
                color: getColor(data.color),
                borderRadius: '8px',
                border: '1px solid #606060',
                cursor: `${data.isDraggable ? 'auto' : 'not-allowed'}`,
                ...userColorStyle
            }}
            onClick={() => { if (!showInfo && !data.isBirthday) { setShowInfo(true) } }}
        // key={data.key}
        >
            {children}
            {data.rec_index !== undefined ? (
                <RxUpdate className='apt-recursive-icon' size={14} />
            ) : (<></>)}
            {isShared ? (
                <ImShare2 className='apt-recursive-icon' style={data.rec_index !== undefined&&{bottom: '20pt'}} size={14} />
            ) : (<></>)}
            <Modal show={showInfo} onHide={() => { setShowInfo(false); }} >
                <ModalHeader closeButton>
                    <ModalTitle className='nac-title'>{data.title}</ModalTitle>
                </ModalHeader>
                <ModalBody className='' >
                    <Row className='my-4 mx-3 nac-text light-color' style={{ alignItems: 'center' }}>
                        <span className='color-circle' style={{ backgroundColor: data.color }} />
                        {data.category.label}
                    </Row>
                    {data.allDay ? (
                        <Row className='mt-4 mx-3 nac-text light-color'>
                            {textContext.get(['event', 'info_event'], ['tot_day'], textContext.value)} {moment(data.startDate, 'YYYY-MM-DDTHH:mm').format("DD/MM/YYYY")}
                        </Row>
                    ) : (
                        <>
                            <Row className='mt-4 mx-3 nac-text light-color'>
                                {textContext.get(['event', 'info_event'], ['date'], textContext.value)} {moment(data.startDate, 'YYYY-MM-DDTHH:mm').format("DD/MM/YYYY")}
                            </Row>
                            <Row className='mt-4 mx-3 nac-text light-color'>
                                {textContext.get(['event', 'info_event'], ['from'], textContext.value)} {moment(data.startDate, 'YYYY-MM-DDTHH:mm').format("HH:mm")}
                            </Row>
                            <Row className='mt-1 mx-3 nac-text light-color'>
                                {textContext.get(['event', 'info_event'], ['to'], textContext.value)} {moment(data.endDate, 'YYYY-MM-DDTHH:mm').format("HH:mm")}
                            </Row>
                        </>
                    )}

                    {data.isAppointment ? (
                        <Row className='my-4 mx-3 nac-text light-color' style={{ cursor: 'pointer' }} onClick={() => navigate(`/customers?cID=${data.customer.value}`)}>
                            {textContext.get(['event', 'info_event'], ['price'], textContext.value)}  {data.price}<br />
                            {textContext.get(['event', 'info_event'], ['client'], textContext.value)} {data.customer_info} <br />
                            {data.contact ? textContext.get(['event', 'info_event'], ['on_contact'], textContext.value) : textContext.get(['event', 'info_event'], ['off_contact'], textContext.value)}
                        </Row>
                    ) : (<></>)}
                    {data.rec_index ? (
                        <Row className='my-4 mx-3 nac-text light-color'>
                            {data.isAppointment ? (
                                <>{textContext.get(['event', 'info_event'], ['name_app'], textContext.value)}</>
                            ) : (
                                <>{textContext.get(['event', 'info_event'], ['name_eve'], textContext.value)} </>
                            )}
                        </Row>
                    ) : (<></>)}
                    <Row className='my-4 mx-3 nac-text light-color'>
                        {textContext.get(['event', 'info_event'], ['ass'], textContext.value)} {data.owner.use_username}<br />
                        {textContext.get(['event', 'info_event'], ['cre'], textContext.value)} {data.creator.use_username}
                    </Row>
                    <Row className='my-4 mx-3 nac-text light-color'>
                        {textContext.get(['event', 'info_event'], ['notes'], textContext.value)} {data.note}
                    </Row>
                </ModalBody>
                <ModalFooter className='d-block'>
                    {data.isAppointment ? (
                        <Row>
                            <Col xs={3} className='d-flex justify-content-center'>
                                <button type="button" className='nac-button light-color'>
                                    <RiPrinterLine onClick={createPdf} size={'3vh'} />
                                </button>
                            </Col>
                            <Col xs={3}>
                            </Col>
                            <Col xs={3} className='d-flex justify-content-center'>
                                {getPermission('gro_aer_apt', 2) && (
                                    <button type="button" className='nac-button light-color'>
                                        <RiDeleteBin6Line onClick={() => { setShowInfo(false); showDeleteEvent() }} size={'3vh'} />
                                    </button>
                                )}
                            </Col>
                            <Col xs={3} className='d-flex justify-content-center'>
                                {getPermission('gro_aer_apt', 1) && (
                                    <button type="button" className='nac-button light-color' onClick={() => setShowEdit(true)}>
                                        <RiEditBoxLine size={'3vh'} />
                                    </button>
                                )}
                            </Col>
                        </Row>
                    ) : (
                        <Row>
                            <Col xs={3} className='d-flex justify-content-center'>
                                {getPermission('gro_aer_event', 2) && (
                                    <button type="button" className='nac-button light-color'>
                                        <RiDeleteBin6Line onClick={() => { setShowInfo(false); showDeleteEvent() }} size={'3vh'} />
                                    </button>
                                )}
                            </Col>
                            <Col xs={6}>
                            </Col>
                            <Col xs={3} className='d-flex justify-content-center'>
                                {getPermission('gro_aer_event', 1) && (
                                    <button type="button" className='nac-button light-color' onClick={() => setShowEdit(true)}>
                                        <RiEditBoxLine size={'3vh'} />
                                    </button>
                                )}
                            </Col>
                        </Row>
                    )}
                </ModalFooter>
            </Modal>
            <Modal show={showDelete} onHide={() => { setShowDelete(false); setShowInfo(true) }} >
                <ModalHeader closeButton>
                    <ModalTitle className='nac-title'>{textContext.get(['event', 'delete_event'], ['title'], textContext.value)} {data.note}</ModalTitle>
                </ModalHeader>

                <ModalBody className='' >
                    <Row className='mt-4 mx-3 nac-text light-color'>
                        {textContext.get(['event', 'delete_event'], ['description'], textContext.value)}
                    </Row>
                </ModalBody>
                <ModalFooter className='d-block'>
                    <Row>
                        <Col xs={3} className='d-flex justify-content-center'>
                            <button type="button" className='nac-button light-color'>
                                <RiCloseLine onClick={() => { setShowDelete(false); setShowInfo(true) }} size={'3vh'} />
                            </button>
                        </Col>
                        <Col xs={6}>
                        </Col>
                        <Col xs={3} className='d-flex justify-content-center'>
                            <button type="button" className='nac-button light-color' >
                                <RiCheckLine onClick={deleteEvent} size={'3vh'} />
                            </button>
                        </Col>
                    </Row>
                </ModalFooter>
            </Modal>
            <Modal show={showDeleteRec} onHide={() => { setShowDeleteRec(false); setShowInfo(true) }} >
                <ModalHeader closeButton>
                    <ModalTitle className='nac-title'>{textContext.get(['event', 'delete_event'], ['title'], textContext.value)} {data.note}</ModalTitle>
                </ModalHeader>

                <ModalBody className='' >
                    <Row className='mt-4 mx-3 nac-text light-color'>
                        {textContext.get(['event', 'info_event'], ['del'], textContext.value)}
                    </Row>
                </ModalBody>
                <ModalFooter className='d-block'>
                    <Row>
                        <Col className='d-flex justify-content-center'>
                            <button type="button" onClick={() => { setShowDeleteRec(false); setShowInfo(true) }} className='nac-button light-color'>
                                {textContext.get(['event', 'info_event'], ['back'], textContext.value)}
                            </button>
                        </Col>
                        <Col className='d-flex justify-content-center'>
                            <button type="button" onClick={() => deleteEvent(1)} className='nac-button light-color' >
                                {textContext.get(['event', 'info_event'], ['only'], textContext.value)}
                            </button>
                        </Col>
                        <Col className='d-flex justify-content-center'>
                            <button type="button" onClick={() => deleteEvent(2)} className='nac-button light-color' >
                                {textContext.get(['event', 'info_event'], ['all'], textContext.value)}
                            </button>
                        </Col>
                    </Row>
                </ModalFooter>
            </Modal>
            <Modal show={showEdit} onHide={() => setShowEdit(false)} >
                <ModalHeader closeButton>
                    <ModalTitle className='nac-title'>{textContext.get(['event', 'custom_event'], ['title'], textContext.value)}</ModalTitle>
                </ModalHeader>

                <ModalBody>
                    <Row className='mt-4 mx-4'>
                        <Col className='ms-2 me-3'>
                            <InputGroup hasValidation>
                                <InputGroup.Text>{textContext.get(['event', 'custom_event'], ['date'], textContext.value)}</InputGroup.Text>
                                <FormControl
                                    type='date'
                                    value={values.date}
                                    onChange={(e) => setValues(draft => { draft.date = e.target.value })}
                                    onFocus={(e) => setFormChecks(draft => { draft.touched.date = true })}
                                    isValid={formChecks.good.date}
                                    isInvalid={formChecks.bad.date}
                                />
                            </InputGroup>
                        </Col>
                    </Row>
                    <Row className='mt-3 mx-4'>
                        <Col className='ms-2 me-3'>
                            <GoodSwitch
                                label={textContext.get(['event', 'custom_event'], ['is_apt'], textContext.value)}
                                value={isAppointment}
                                onChange={switchIsAppointment}
                            />
                        </Col>
                    </Row>
                    <Row className='mt-3 mx-4'>
                        <Col className='ms-2 me-3'>
                            <Form.Label className='light-color'>{textContext.get(['event', 'custom_event'], ['select'], textContext.value)}</Form.Label>
                            {refreshSelect ? (
                                <Select
                                    id='select-pdp'
                                    components={animatedComponents}
                                    options={categoryOptions.filter(cat => cat.value.apt == isAppointment && cat.value.ID != 0)}
                                    value={values.category}
                                    onChange={(e) => setValues(draft => { draft.category = e; /*draft.title = `${draft.category ? draft.category.label : ''} ${draft.customer ? draft.customer.label : ''}`;*/ setTime(e) })}
                                    onFocus={(e) => setFormChecks(draft => { draft.touched.category = true })}
                                    isValid={formChecks.good.category}
                                    isInvalid={formChecks.bad.category}
                                />
                            ) : (
                                <Row className='my-4'>

                                </Row>
                            )}
                        </Col>
                    </Row>
                    {isAppointment && (
                        <>
                            <Row className='mt-3 mx-4'>
                                <Col className='ms-2 me-3'>
                                    <Form.Label className='light-color'>{textContext.get(['event', 'custom_event'], ['select2'], textContext.value)}</Form.Label>
                                    <Select
                                        id='select-pep'
                                        components={animatedComponents}
                                        options={customerOptions}
                                        isSearchable={true}
                                        value={values.customer}
                                        onChange={(e) => setValues(draft => { draft.customer = e;/* draft.title = `${draft.category ? draft.category.label : ''} ${draft.customer ? draft.customer.label : ''}`*/ })}
                                        onFocus={(e) => setFormChecks(draft => { draft.touched.customer = true })}
                                        isValid={formChecks.good.customer}
                                        isInvalid={formChecks.bad.customer}
                                    />
                                </Col>
                            </Row>
                            <Row className='mt-3 mx-4'>
                                <Col className='ms-2 me-3'>
                                    <GoodSwitch
                                        label={textContext.get(['event', 'custom_event'], ['is_contact'], textContext.value)}
                                        value={values.contact}
                                        onChange={(e) => { setValues(draft => { draft.contact = e }) }}
                                    />
                                </Col>
                            </Row>
                        </>
                    )}
                    {globalContext.get.Agency.age_max_users != 1 ?
                    <Row className='mt-3 mx-4'>
                        <Col className='ms-2 me-3'>
                            <Form.Label className='light-color'>{textContext.get(['event', 'info_event'], ['ass'], textContext.value)}</Form.Label>
                            <Select
                                id='select-pdwp'
                                components={animatedComponents}
                                options={userOptions}
                                value={values.owner}
                                onChange={(e) => setValues(draft => { draft.owner = e })}
                            />
                        </Col>
                    </Row>
                    :<></>}
                    <hr />
                    <Row className='mt-3 mx-4'>
                        <Col className='ms-2 me-3'>
                            <GoodSwitch
                                label={textContext.get(['event', 'custom_event'], ['total'], textContext.value)}
                                value={values.allDay}
                                onChange={(e) => { setValues(draft => { draft.allDay = e }) }}
                            />
                        </Col>
                    </Row>
                    {!values.allDay && (
                        <Row className='mt-1 mx-4'>
                            <Col className='ms-2 me-3'>
                                <InputGroup hasValidation>
                                    <InputGroup.Text>{textContext.get(['event', 'custom_event'], ['start'], textContext.value)}</InputGroup.Text>
                                    <FormControl
                                        type='time'
                                        value={values.start}
                                        max={end}
                                        onChange={(e) => setTimeStart(e.target.value)}
                                    />
                                </InputGroup>
                            </Col>
                            <Col className='ms-3 me-2'>
                                <InputGroup hasValidation>
                                    <InputGroup.Text>{textContext.get(['event', 'custom_event'], ['finish'], textContext.value)}</InputGroup.Text>
                                    <FormControl
                                        type='time'
                                        value={end}
                                        min={values.start}
                                        onChange={(e) => setTimeEnd(e.target.value)}
                                    />
                                </InputGroup>
                            </Col>
                        </Row>
                    )}
                    <hr />
                    {/* <Row className='my-3 mx-4'>
                        <Col className='ms-2 me-3'>
                            <GoodSwitch
                                label={textContext.get(['event', 'info_event'], ['divieto'], textContext.value)}
                                value={values.autogen_title}
                                onChange={(e) => setValues(draft => { draft.autogen_title = e })}
                            />
                        </Col>
                    </Row> */}
                    <Row className='mt-4 mx-4'>
                        <Col className='ms-2 me-3'>
                            <InputGroup hasValidation>
                                <InputGroup.Text>{textContext.get(['event', 'custom_event'], ['title2'], textContext.value)}</InputGroup.Text>
                                <FormControl
                                    type='text'
                                    value={values.title}
                                    onChange={(e) => setValues(draft => { draft.title = e.target.value })}
                                    onFocus={(e) => setFormChecks(draft => { draft.touched.title = true })}
                                    isValid={formChecks.good.title}
                                    isInvalid={formChecks.bad.title}
                                    // disabled={values.autogen_title}
                                />
                            </InputGroup>
                        </Col>
                    </Row>
                    <Row className='mt-4 mx-4'>
                        <Col className='ms-2 me-3'>
                            <InputGroup hasValidation>
                                <InputGroup.Text>{textContext.get(['event', 'custom_event'], ['notes'], textContext.value)}</InputGroup.Text>
                                <FormControl
                                    type='text'
                                    as="textarea"
                                    value={values.note}
                                    onChange={(e) => setValues(draft => { draft.note = e.target.value })}
                                    onFocus={(e) => setFormChecks(draft => { draft.touched.note = true })}
                                    isValid={formChecks.good.note}
                                    isInvalid={formChecks.bad.note}
                                />
                            </InputGroup>
                        </Col>
                    </Row>
                    <hr />
                    {data.rec_ID ? (
                        <Row className='mt-4 mb-2 mx-2 d-flex justify-content-end'>
                            <Col xs={2} className='d-flex justify-content-center'>
                                <button type="button" className='nac-button' onClick={resetEdit}>
                                    <RiCloseLine size={`24pt`} />
                                </button>
                            </Col>
                            <Col xs={4} className='d-flex justify-content-center'>
                                <button type="button" className='nac-button' onClick={() => { handleEditSubmit(1) }}>
                                    {textContext.get(['event', 'custom_event'], ['edit'], textContext.value)}
                                </button>
                            </Col>
                            <Col xs={4} className='d-flex justify-content-center'>
                                <button type="button" className='nac-button' onClick={() => { handleEditSubmit(2) }}>
                                    {textContext.get(['event', 'custom_event'], ['edit_all'], textContext.value)}
                                </button>
                            </Col>
                        </Row>
                    ) : (
                        <Row className='mt-4 mb-2 mx-4'>
                            <Col xs={9} >
                            </Col>
                            <Col xs={2} className='d-flex justify-content-center'>
                                <button type="button" className='nac-button' onClick={resetEdit}>
                                    <RiCloseLine size={`24pt`} />
                                </button>
                            </Col>
                            <Col xs={1} className='d-flex justify-content-center'>
                                <button type="button" className='nac-button' onClick={() => { handleEditSubmit(0) }}>
                                    <RiCheckLine size={`24pt`} />
                                </button>
                            </Col>
                        </Row>
                    )}
                </ModalBody>
            </Modal>
        </Appointments.Appointment>
    )
}
export default Appointment

